import fetchInterceptor , {FetchOptions} from "../../../utils/fetchInterceptor ";
import { newsEndpoints } from "../apiEndPoints";
import { header } from "../../../context/constant";

const DeleteNewsAPI = async (id: string) => {
  const url = newsEndpoints.delete(id);
  const options: FetchOptions = {
    method: "DELETE",
    headers: header,
  };
  return fetchInterceptor(url, options);
};

export default DeleteNewsAPI;